var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-tooltip", {
    attrs: { top: "" },
    scopedSlots: _vm._u([
      {
        key: "activator",
        fn: function ({ on, attrs }) {
          return [
            _c(
              "v-btn",
              _vm._g(
                _vm._b(
                  {
                    staticClass: "mr-2",
                    attrs: { icon: "", small: "", rounded: "" },
                    on: { click: _vm.handleClick },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                on
              ),
              [
                _c(
                  "v-icon",
                  { class: _vm.iconClass, attrs: { "aria-label": _vm.label } },
                  [_vm._v(_vm._s(_vm.icon))]
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "py-1 px-3 d-flex align-center" },
              [
                !_vm.allowed
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { color: "white", small: "" },
                      },
                      [
                        _vm._v(
                          "\n                mdi-lock-outline\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.label))]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }